import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareT = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler23') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler23', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Cerb crystal!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Cerb crystal!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareT}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareT
  
